module.exports = __webpack_public_path__ + "static/media/06_cancer.ffbcc961.svg";